import { AxiosInstance } from 'axios';
import { Vue } from 'vue/types/vue';
import { Component, VueConstructor } from 'vue/types';
import { VueRouter } from 'vue-router/types/router';
import { ElMessage } from 'element-ui/types/message';
import { ElMessageBox } from 'element-ui/types/message-box';
import ExtensionManager from './extension';
import Fn from './fn'

class Sdk {
  public http?: AxiosInstance;
  public router?: VueRouter;
  public message?: ElMessage;
  public msgbox?: ElMessageBox;
  public utils: { [key: string]: any } = {};
  public components: { [key: string]: Component } = {};
  public exts?: ExtensionManager;
  public vue?: Vue;
  public Vue?: VueConstructor;
  public publicFunction: { [key: string]: any } = {};
  public componentsDefaults?: { [key: string]: any } ;
  public Fn!: Fn;

  public init(vue: Vue, args: SdkArguments) {
    this.http = vue.$axios;
    this.router = vue.$router;
    this.message = vue.$message;
    this.msgbox = vue.$msgbox;
    this.vue = vue;
    this.Vue = args.Vue;
    this.exts = new ExtensionManager(this.router, args.routeParent);

    this.utils = { id: args.UUID, ...args.plugins };

    this.components = args.components;

    this.Fn = new Fn(vue.$message, vue.$msgbox, vue.$axios, this.utils);
  }

  // 给sdk添加自定义控件
  public addCustomComponent(object: any) {
    this.components = Object.assign(this.components, object);
  }

  // 在sdk中注册控件，平台会合并引入sdk中注册的控件
  public registerComponent(object: any){
    this.componentsDefaults = object
  }

  // 给sdk添加公用的方法，为了给页面js使用扩展包公用方法
  public addPublicFunction (object: { [key: string]: any }) {
    this.publicFunction = Object.assign(this.publicFunction, object);
  }
}

interface SdkArguments {
  plugins: { [key: string]: any; };
  Vue: VueConstructor;
  UUID: any;
  routeParent: VueConstructor;
  components: { [key: string]: Component };
}

const sdk: Sdk = new Sdk();

export default sdk;
